import * as React from "react";

import "./loading-spinner.scss";

import {makeChain} from "@Common/react/cst2";
import {Types}     from "@Common/types";


export const LoadingSpinner = ({
    text  = "",
}:{
    text ?: string,
}) => (

    makeChain<JSX.Element>()

    // render the spinner
    .then(() => (
        <p className="loading-spinner-54b">
            <img className="spinner" src="assets/SPINNER_NO_TEXT.svg"/>
            {text}
        </p>
    ))

    .run()

);
